/** FSSAI-style marks: green square-dot for veg, brown triangle for non-veg, yellow for egg. */
export function FoodTypeMark({ type, className = 'size-3.5' }) {
  const color = type === 'non_veg' ? '#7c2d12' : type === 'egg' ? '#ca8a04' : '#15803d';
  const label = type === 'non_veg' ? 'Non-veg' : type === 'egg' ? 'Contains egg' : 'Veg';
  return (
    <svg viewBox="0 0 16 16" className={`shrink-0 ${className}`} role="img" aria-label={label}>
      <title>{label}</title>
      <rect x="1" y="1" width="14" height="14" rx="2" fill="#fff" stroke={color} strokeWidth="1.6" />
      {type === 'non_veg' ? (
        <path d="M8 4 L12 11.5 H4 Z" fill={color} />
      ) : (
        <circle cx="8" cy="8" r="3.6" fill={color} />
      )}
    </svg>
  );
}
